import { ProductAdjustmentModel } from 'api-hooks/product/adjustment/model';
import { generateId } from 'common/utils/string';
import React from 'react';

import {
  ProductAdjustmentFormType,
  ProductAdjustmentItemFormType,
} from '../components/form-type';

export function onAddNewProductVariant(): ProductAdjustmentItemFormType {
  return {
    productVariantId: undefined,
    type: '',
    description: '',
    stock: undefined,
    qty: undefined,
    price: undefined,
    totalPrice: undefined,
    customId: generateId(),
    tempPrice: undefined,
  } as unknown as ProductAdjustmentItemFormType;
}

export default function useGetDefaultValues(
  productAdjustment?: ProductAdjustmentModel,
) {
  const defaultValues = React.useMemo<ProductAdjustmentFormType>(() => {
    const items: ProductAdjustmentItemFormType[] =
      productAdjustment?.productAdjustmentItems?.map((pv) => {
        return {
          productVariantId: {
            id: pv.productVariant.id,
            label: pv.completeName,
          },
          type: pv.type,
          description: pv.description || '',
          stock: pv.productVariant.stock,
          qty: pv.qty,
          price: pv.price || undefined,
          totalPrice: pv.qty * pv.price || undefined,
          customId: generateId(),
          tempPrice: pv.price || pv.productVariant.sellPrice,
        };
      }) ?? [onAddNewProductVariant()];

    return {
      transactionAt: productAdjustment?.transactionAt || new Date(),
      description: productAdjustment?.description || '',
      items,
      productAdjustment,
    };
  }, [productAdjustment]);

  return defaultValues;
}
